import React, { ReactNode } from 'react';
import cc from 'classnames';
import { Button } from '@material-ui/core';
import { NavigateBeforeRounded } from '@material-ui/icons';

import styles from './NavigateBackStep.module.css';

export enum BackThemes {
  link = 'link',
  button = 'button',
}

type Props = {
  children?: ReactNode;
  className?: string;
  onClick?: () => void;
};

const NavigateBackStep = ({ children, className, onClick }: Props) => (
  <Button type="button" className={cc(styles.back, styles.link, className)} onClick={onClick}>
    <NavigateBeforeRounded /> {children}
  </Button>
);

export default NavigateBackStep;
